import { motion } from "framer-motion";
import { Reveal, EASE } from "@/lib/motion";
import { PROCESS } from "@/lib/site-data";

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative overflow-hidden py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <span className="eyebrow">How it works</span>
          <h2 className="mt-5 font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
            A clear, calm process from idea to launch
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/60 md:text-lg">
            No jargon, no guesswork. Four simple steps designed to keep you informed
            and confident the whole way through.
          </p>
        </Reveal>

        <div className="mt-16 space-y-2">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.05 }}
              data-testid={`process-step-${p.step}`}
              className="group grid grid-cols-1 items-center gap-4 border-t border-white/10 py-8 transition-colors duration-300 hover:border-white/25 md:grid-cols-[auto_1fr_2fr] md:gap-10"
            >
              <span className="font-heading text-6xl font-semibold text-white/10 transition-colors duration-500 group-hover:text-gradient md:text-7xl">
                {p.step}
              </span>
              <h3 className="font-heading text-2xl font-semibold text-white">
                {p.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-white/55">
                {p.text}
              </p>
            </motion.div>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
};

export default Process;
